import type { SATTestInterventionArmAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import SATTestQ from './SATTestQ'
import SATTestUserInterventionArmQ from './SATTestUserInterventionArmQ'

const SATTestInterventionArmQ = {
  ...makeQueryModelV2<SATTestInterventionArmAttributes>('sat_test_intervention_arm')([
    'id',
    'created_at',
    'name',
    'group_slug',
    'user_type',
    'weight',
    'sat_test_id',
    'created_at',
    'deleted_at',
    'updated_at',
  ]),

  associations: (): AssociationDefinitions => ({
    SATTest: {
      query: SATTestQ,
      foreignKey: SATTestQ.id,
      sourceKey: SATTestInterventionArmQ.sat_test_id,
    },
  }),

  where: (
    {
      id = null,
      include = [],
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATTestInterventionArmAttributes> => SQL`
        FROM ${SATTestInterventionArmQ}
        ${includeAssociationsToSql(SATTestInterventionArmQ, include)}
        WHERE
            ${id != null ? SQL`${SATTestInterventionArmQ.id} = ${id} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
    `,

  countUsers: (): SQLFragment<number> => SQL`
    COUNT(*) ${SATTestUserInterventionArmQ.where({
      satTestInterventionArmId: SATTestInterventionArmQ.id,
    })}
  `,
}

export default SATTestInterventionArmQ
